import { useSyncExternalStore } from 'react'

// Google calls window.gm_authFailure() when the Maps key is rejected (referer, quota, billing);
// @vis.gl/react-google-maps 1.9 declares AUTH_FAILURE but never sets it, so we listen ourselves.
// Installed once on first use and kept for the page's life, so a failure arriving after the user
// left ARV is still recorded; the flag is sticky because a rejected key stays rejected until reload.
let failed = false
let installed = false
const listeners = new Set()

function install() {
  installed = true
  const previous = window.gm_authFailure
  window.gm_authFailure = () => {
    failed = true
    listeners.forEach(fn => fn())
    if (typeof previous === 'function') previous()
  }
}

function subscribe(listener) {
  if (!installed && typeof window !== 'undefined') install()
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => failed

export function useMapsAuthFailed() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

// Tests only: module state outlives a single render and a single test.
export function __resetMapsAuthFailure() {
  failed = false
  installed = false
}
